import _ from 'lodash';
import React, { useContext, useState } from 'react';
import PropertyUtil from 'src/util/PropertyUtil';
import SearchResult from 'src/models/OwnerSearchResult';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { UseFormMethods } from 'react-hook-form';
import AddOwnershipPages from './AddOwnershipPages';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { AnyObject } from 'final-form';
import OwnerTracts from '../owners/OwnerTracts';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import LeaseGenerationTractDetail from 'src/models/leasing/LeaseGenerationTractDetail';

interface IOwnerLandingPageStateProps extends Partial<Pick<UseFormMethods, 'register' | 'getValues' | 'setValue'>> {
    searchResults: SearchResult[];
    ownerTracts: Array<LeaseGenerationTractDetail>;

    selectOwner: (i: number) => void;
    turnPage: (page: AddOwnershipPages) => void;
    getOwnerDetail: (ownerLookupId: number) => void;
    onAttachOwner: () => void;
    searchOwners: (searchText: string) => void;
}

const OwnerLandingPage: React.FC<IOwnerLandingPageStateProps> = (props: IOwnerLandingPageStateProps) => {
    const appContext = useContext<IAppContextState>(AppContext);

    const [searchString, setSearchString] = useState<string>(null);

    const searchUpdate = _.debounce((searchText: string) => {
        console.log(searchText);
        setSearchString(searchText);
        props.searchOwners(searchText);
    }, 300);

    const getTractsByOwnerId = async (p: SearchResult, index: number) => {
        props.selectOwner(index);
        props.getOwnerDetail(p.id);
    };

    const resultsList = () => {
        if (searchString !== undefined) {
            if (PropertyUtil.SafeGet(() => props.searchResults.length > 0)) {
                console.log('results', props.searchResults);
                return props.searchResults.map((owner, index) => {
                    return (
                        // p.id, p.containerOwnerId, p.type
                        <div className="dialog-card-list" key={owner.id} onClick={() => getTractsByOwnerId(owner, index)}>
                            <div hidden={true}>
                                <RHFInputBox
                                    label=""
                                    name={`owners[${index}].id`}
                                    register={props.register}
                                    type="number"
                                    disabled={true}
                                />
                                <RHFInputBox
                                    label=""
                                    name={`owners[${index}].containerOwnerId`}
                                    register={props.register}
                                    type="number"
                                    disabled={true}
                                />
                                <RHFInputBox
                                    label=""
                                    name={`owners[${index}].type`}
                                    register={props.register}
                                    disabled={true}
                                />
                            </div>
                            <span className="lh-tenth-width">
                                <RHFCheckbox label="" onClick={() => props.selectOwner(index)} name={`owners[${index}].selected`} register={props.register} />
                            </span>
                            <span className="lh-fourth-width">{`${owner.id}`}</span>
                            <span className="lh-fourth-width">{`${owner.name}`}</span>
                            <span className="lh-fourth-width">{`${owner.type}`}</span>
                        </div>
                    );
                });
            } else {
                return <div>No Owners Were Found</div>;
            }
        } else {
            return <div style={{ textAlign: 'center' }}>Enter a ID, First or Last Name to Search for Existing Owners</div>;
        }
    };

    const attachOwner = () => {
        const p: SearchResult = (props.getValues())?.owners?.find((x: SearchResult) => x.selected);
        props.onAttachOwner();
        changeOwnerType(p.type);

        props.setValue('ownerLookUpId', p.id);

        // This is attached to a react node that simply renders WIP - Work In Progress - disabling it for now.
        // props.turnPage(AddOwnershipPages.DeviationDecimalInterest);
    };

    const changeOwnerType = (ownerType: string) => {
        switch (ownerType) {
            case 'Individual':
                props.setValue('ownerType', '0');
                break;

            case 'Trust':
                props.setValue('ownerType', '1');
                break;

            case 'Business':
                props.setValue('ownerType', '2');
                break;

            case 'Gov-BLM':
                props.setValue('ownerType', '3');
                break;

            case 'Gov-RAL':
                props.setValue('ownerType', '4');
                break;

            case 'Gov-STATE':
                props.setValue('ownerType', '5');
                break;

            case 'JointTenant':
                props.setValue('ownerType', '6');
                break;

            case 'BOIA':
                props.setValue('ownerType', '7');
                break;

            default:
                break;
        }
    };

    return (
        <div style={{ height: '50rem', width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                <div style={{ width: '50%', height: '100%', display: 'flex' }}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                        <RHFInputBox
                            name="searchText"
                            label="Search for Existing Owner"
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                searchUpdate(e.target.value)
                            }
                            register={props.register}
                        />
                        <div className="owner-search-results">
                            <div className="dialog-card-list">
                                <span className="lh-tenth-width" />
                                <span className="lh-fourth-width">ID</span>
                                <span className="lh-fourth-width">Name</span>
                                <span className="lh-fourth-width">Type</span>
                            </div>
                            {resultsList()}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1rem' }}>
                            {/* <div>
                                <Button
                                    text="Create New Owner"
                                    onClick={() => props.turnPage(AddOwnershipPages.NewOwnerInfoForm)}
                                />
                            </div> */}
                            {(props.getValues() as AnyObject)?.owners?.some((x: SearchResult) => x && x.selected) && (
                                <div>
                                    <Button text="Attach Owner" className="ml-1" onClick={attachOwner} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div style={{ width: '50%', display: 'flex' }}>
                    <div className="owner-tracts-container">
                        {props.searchResults && props.ownerTracts && <div className="owner-tract-header">Tracts</div>}
                        <OwnerTracts
                            tracts={props.ownerTracts}
                            clientNumber={appContext.clientNumber}
                            projectNumber={appContext.projectNumber}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OwnerLandingPage;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/OwnerLandingPage.tsx